import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ReasonInserieActivaton } from '@core/enums/reason-inserie-activaton.enum';
import { Status } from '@core/enums/status-color.enum';
import { AdminService } from '@core/services/admin.service';
import { AppService } from '@core/services/app.service';
import { AstaktService } from '@core/services/astakt.service';
import { DownloadService } from '@core/services/download.service';
import { ErrorHandlerService } from '@core/services/errorHandler/error-handler.service';
import { SteuerdatenService } from '@core/services/steuerdaten.service';
import { getStatusColor } from '@core/utils/getStatusColor/getStatusColor';
import { entitlements } from '@env/entitlements';
import { FcscSdpDetailsComponent } from '@fcsc/fcsc-uploadtool/fcsc-upload-vorab/components/fcsc-sdp-details/fcsc-sdp-details.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslocoService } from '@ngneat/transloco';
import { AstaktSdpRequest, AstaktSdpResponse } from '@shared/models/Astaktinfo';
import { SeriesSteuerDaten, SeriesSteuerDatenMap } from '@shared/models/filetype/SeriesSteuerDaten';
import { SeriesSteuerDatenHistory } from '@shared/models/filetype/SeriesSteuerDatenHistory';
import { SecurityService } from '@core/services/security.service';
import { ModalResult } from '@shared/models/ModalResult';
import { interval } from 'rxjs/internal/observable/interval';

@Component({
  standalone: false,
  selector: 'app-fcsc-edit-series-modal',
  templateUrl: './fcsc-edit-series-modal.component.html',
  styleUrls: ['./fcsc-edit-series-modal.component.scss'],
})
export class FcscEditSeriesModalComponent implements OnInit {
  radioList!: any;
  @Input() message!: string;
  @Input() titleCurrent!: string;
  @Input() titleNext!: string;
  @Input() titleLast!: string;
  @Input() subTitleLast!: string;
  @Input() notificationMessage!: string;
  @Input() baureihe!: string;
  @Input() bdpContentId!: number;
  @Input() asTaktRequired: boolean = false;
  @Output() emitService = new EventEmitter();
  updateReason!: string;
  wrongBdpReason!: string;
  otherBdpReason!: string;
  bdpInSerieForm!: UntypedFormGroup;
  serieActivationForm!: UntypedFormGroup;
  selectedPacket!: any;
  notificationTitle = '';
  isDirectFlag = false;
  astaktResponse : AstaktSdpResponse;
  astaktVersions!: any;
  defaultVersion: any;
  userEntitlements = this.securityService.getEntitlements();
  showAstaktNotification;
  inSeriesAstakt: string | null = null;

  sortConfig = [{ prop: 'inSeriesSince', dir: 'desc' }];
  seriesHistory!: SeriesSteuerDatenHistory[];
  seriesEditHistory!: SeriesSteuerDatenHistory[];

  public serieBdpDeploytEntitlement = [
    entitlements.VUS.FCSC_SERIEN_DATA,
  ];
  public astaktEntitlement = [entitlements.VUS.FLASHWARE_CALCULATION];

  showDiv = {
    current: false,
    next: false,
    last: false,
  };

  constructor(
    private dataPipe: DatePipe,
    public activeModal: NgbActiveModal,
    private formBuilder: UntypedFormBuilder,
    private notificationService: ErrorHandlerService,
    private translocoService: TranslocoService,
    private appService: AppService,
    private steuerdatenService: SteuerdatenService,
    private modalService: NgbModal,
    private downloadService: DownloadService,
    private astaktService: AstaktService,
    private securityService: SecurityService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    console.log("onint")
    this.updateReason = ReasonInserieActivaton.DATA_UPDATE;
    this.wrongBdpReason = ReasonInserieActivaton.FAULTY_BDP;
    this.otherBdpReason = ReasonInserieActivaton.OTHER;

    this.setTranslation();

    if (!this.bdpContentId) {
      this.activateNewInSerieBdpSelection();
    } else {
      this.getSeriesEditDetails();
      this.getSeriesHistory();
      this.createBdpInSerieForm();

      this.showDiv.current = true;
      this.showDiv.next = false;
      this.showDiv.last = false;
    }
  }

  private createBdpInSerieForm() {
    console.log("create bdp in series called");
    this.bdpInSerieForm = this.formBuilder.group({
      name: new UntypedFormControl(
        this.seriesEditHistory && this.seriesEditHistory[0].name
      ),
      inSeriesSince: new UntypedFormControl(
        this.seriesEditHistory &&
          this.dataPipe?.transform(
            this.seriesEditHistory[0].inSeriesSince,
            'dd.MM.yy, HH:mm:ss'
          )
      ),
      reason: new UntypedFormControl(this.getReasonTranslatedDefaultValue()),
      note: new UntypedFormControl(
        this.seriesEditHistory && this.seriesEditHistory[0].note
      ),
    });
  }

onShowDivLastLoaded() {
  const sdpName = this.selectedPacket?.name || (Array.isArray(this.selectedPacket) && this.selectedPacket[0]?.name);
  if (sdpName) {
    this.fetchAndSetAstaktVersions(sdpName);
  } else {
    this.astaktVersions = [""];
    this.serieActivationForm.get('astaktVersion')?.setValue('');
  }
}

  private createSerieActivationForm() {
    this.serieActivationForm = this.formBuilder.group({
      note: new UntypedFormControl(''),
      reason: new UntypedFormControl(
        this.appService.getValueConstant(
          ReasonInserieActivaton,
          ReasonInserieActivaton.DATA_UPDATE
        )
      ),
      name: new UntypedFormControl(''),
      astaktVersion: new UntypedFormControl(''),
    });

    if (!this.asTaktRequired) {
      this.serieActivationForm.get('astaktVersion')?.disable();
    }

    this.notificationTitle = this.translocoService.translate(
      'modules.data-management.serien-daten.modal.bdp-activation-notification-title',
      {
        selected:
          this.seriesEditHistory && this.seriesEditHistory[0].name
            ? this.seriesEditHistory[0].name
            : '',
      }
    );
  }

  public activateNewInSerieBdpSelection() {
    this.showDiv.current = false;
    this.showDiv.next = true;
    this.createSerieActivationForm();
  }

  activateNewInSerieBdpSelectionHistory() {
    this.showDiv.current = false;
    this.showDiv.next = false;
    this.showDiv.last = true;
    this.createSerieActivationForm();
  }

  handleDirectNavigation(row) {
    this.showAstaktNotification = false;
    this.isDirectFlag = true;
    const packetSelected = { name: row.name };
    if (packetSelected) {
      const event = [packetSelected];
      this.activateNewInSerieBdpSelectionHistory();
      this.packetSelectedEvent(event);
    }
  }

  public viewInSerieSdpData() {
    const modalRef = this.modalService.open(FcscSdpDetailsComponent, {
      size: 'lg',
      windowClass: 'bdp-edit-modal override',
      backdrop: 'static',
      keyboard: false,
    });
    modalRef.componentInstance.title = this.translocoService.translate(
      'modules.data-management.sdp-details-title',
      { name: this.bdpInSerieForm.get('name')?.value }
    );

    modalRef.componentInstance.sdpName = this.bdpInSerieForm.get('name')?.value;
    modalRef.componentInstance.showCrossClose = false;

  }

  packetSelectedEvent(event) {
    this.selectedPacket = event;
    this.showAstaktNotification = false;
    this.serieActivationForm.controls.name.setValue(this.selectedPacket[0]?.name);
    this.fetchAndSetAstaktVersions(event[0].name, true);
    this.notificationMessage =
      this.selectedPacket && this.selectedPacket.name
        ? this.selectedPacket.name
        : '';
    this.emitService.emit(this.selectedPacket);
  }

  private fetchAndSetAstaktVersions(sdpName: string, updateSelectedPacket: boolean = false): void {
    const payload: AstaktSdpRequest = { sdps: [sdpName] };
    
    this.steuerdatenService.getInSeriesAstaktForBaureihe(this.baureihe).subscribe({
      next: (inSeriesData: SeriesSteuerDaten | null) => {
        this.inSeriesAstakt = inSeriesData?.asTakt || null;
        this.processAstaktResponse(payload, updateSelectedPacket);
      },
      error: () => {
        this.inSeriesAstakt = null;
        this.processAstaktResponse(payload, updateSelectedPacket);
      }
    });
  }
  private processAstaktResponse(payload: AstaktSdpRequest, updateSelectedPacket: boolean): void {
    this.astaktService.getAstaktSDP(payload).subscribe({
      next: (response) => {
        try {
          const dataArray = response.body || response;
          if (Array.isArray(dataArray) && dataArray.length > 0) {
            const firstItem = dataArray[0];
            const backendVersions = [...firstItem.validVersions.FOR_PROMOTION];
            let versions: string[];

            // If previous SDP was promoted with AS-Takt and it exists in backend versions
            if (this.inSeriesAstakt && backendVersions.includes(this.inSeriesAstakt)) {
              // Find index of previous version and take inSeriesAstakt + next 3 versions
              const prevIndex = backendVersions.indexOf(this.inSeriesAstakt);
              // Include inSeriesAstakt and next 3 versions (total 4 versions)
              versions = backendVersions.slice(prevIndex, prevIndex + 4);
            } else {
              // No previous AS-Takt promotion: use all versions
              versions = backendVersions;
            }

            this.astaktVersions = versions;

            // Always preselect the 3rd element (index 2) from the original backend versions
            if (this.asTaktRequired) {
              this.defaultVersion = backendVersions.length > 2 ? backendVersions[2] : (backendVersions[0] || '');
            } else {
              this.defaultVersion = '';
            }

            this.serieActivationForm.get('astaktVersion')?.setValue(this.defaultVersion);

            if (updateSelectedPacket && this.selectedPacket?.[0]) {
              this.selectedPacket[0].astaktVersions = this.astaktVersions;
              this.selectedPacket[0].defaultOrSelectedVersion = this.defaultVersion;
            }

            this.scheduleAstaktNotification();
          }
        } catch (e) {
          this.astaktVersions = ["NO_VERSIONS_FOUND"];
          this.serieActivationForm.get('astaktVersion')?.setValue('');
          this.scheduleAstaktNotification();
        }
      }
    });
  }

  private scheduleAstaktNotification(): void {
    setTimeout(() => {
      this.showAstaktNotification =
        this.selectedPacket?.[0] && this.checkVersions();
      this.cdr.detectChanges();
    }, 2000);
  }

  getSeriesEditDetails() {
    this.steuerdatenService.getSeriesEditDetails(this.baureihe).subscribe(
      (data: SeriesSteuerDatenHistory[]) => {
        this.seriesEditHistory = data;
        this.createBdpInSerieForm();
        this.cdr.detectChanges();
      },
      (error: HttpErrorResponse) => {
        this.notificationService.handleServerErrorNotification(error, '');
      }
    );
  }

  private getSeriesHistory(): void {
    this.steuerdatenService.getSeriesHistory(this.baureihe).subscribe(
      (seriesHistoryData: SeriesSteuerDatenHistory[]) => {
        this.seriesHistory = seriesHistoryData;
        this.cdr.detectChanges();
      },
      (error: HttpErrorResponse) => {
        this.notificationService.handleServerErrorNotification(error, '');
      }
    );
  }

  sdPaketsDetails(row: SeriesSteuerDatenMap, value: string): void {
    const modalRef = this.modalService.open(FcscSdpDetailsComponent, {
      size: 'lg',
      windowClass: 'bdp-edit-modal override',
      backdrop: 'static',
      keyboard: false,
    });
    const selectedRow: SeriesSteuerDatenMap = row;
    modalRef.componentInstance.title = this.translocoService.translate(
      'modules.data-management.sdp-details-title',
      { name: selectedRow.name }
    );

    modalRef.componentInstance.sdpName = value;
    modalRef.componentInstance.showCrossClose = false;

  }

  public exportSdpFiles(sdp: SeriesSteuerDatenMap): void {
    const selectedRowName = sdp.name;

    this.steuerdatenService
      .getExportFilesAsZipDownload(sdp.steuerDatenPaketId)
      .subscribe(
        (response) => {
          this.downloadService.createAndDownloadFile(
            response,
            `${selectedRowName}`,
            '.zip'
          );
        },
        (error: HttpErrorResponse) => {
          this.notificationService.handleServerErrorNotification(error, '');
        }
      );
  }

  // This is called when translation is triggered.
  setTranslation(): void {
    this.appService.languageSubject.subscribe(() => {
      setTimeout(() => {
        this.setReasonInitialValue();
      }, 100);
    });
  }

  setReasonInitialValue(): void {
    this.bdpInSerieForm
      .get('reason')
      ?.setValue(this.getReasonTranslatedDefaultValue());
  }

  getReasonTranslatedDefaultValue(): void {
    return this.translocoService.translate(
      ReasonInserieActivaton[
        this.seriesEditHistory &&
          (this.seriesEditHistory[0]
            ?.reason as keyof typeof ReasonInserieActivaton)
      ]
    );
  }

  public getColor(value: string): string {
    const enumValue = Status[value as keyof typeof Status];
    return getStatusColor(enumValue);
  }

  public getValue(value: string): string {
    return Status[value as keyof typeof Status] || value;
  }

  // modal buttons
  public selectBdp(): void {
    console.log("choose package called");
    this.showDiv.current = false;
    this.showDiv.next = false;
    this.showDiv.last = true;
    this.onShowDivLastLoaded();
  }

  public checkBdpSelection(): boolean {
  return this.selectedPacket && this.selectedPacket.length === 1;
  }

  public onAstaktVersionSelected(version: string): void {
    if (this.selectedPacket?.[0]) {
      this.selectedPacket[0].defaultOrSelectedVersion = version;
    }
  }

  public checkVersions(): boolean {
    return !this.selectedPacket[0]?.astaktVersions || this.selectedPacket[0]?.astaktVersions == "";
  }
  public validAstakt(): boolean {
    if (!this.asTaktRequired) {
      return false;
    }
    if(!this.selectedPacket[0]?.astaktVersions){
      return false;
    }
    const hasVersions = this.selectedPacket[0]?.astaktVersions[0]?.length > 0 && this.selectedPacket[0]?.astaktVersions[0] !== '';
    return hasVersions && this.selectedPacket[0]?.defaultOrSelectedVersion === '';
  }

  public activateInSerie(): void {
    
    const astaktVersions = Array.isArray(this.selectedPacket)
      ? this.selectedPacket.map((packet: any) => packet.defaultOrSelectedVersion ?? '')
      : [this.selectedPacket?.defaultOrSelectedVersion ?? ''];
    this.serieActivationForm.get('astaktVersions')?.setValue(astaktVersions);
    const packets = Array.isArray(this.selectedPacket) ? this.selectedPacket : [this.selectedPacket];
    const hasInSeries = packets.some((packet: any) => packet?.status === 'IN_SERIES');
    const result: any = {
      ok: ModalResult.ACTIVATION_SUCCESSFUL,
      form: this.serieActivationForm,
    };
    if (hasInSeries) {
      result.forceRepromote = true;
    }
    this.activeModal.close(result);
  }

  public close(): void {
    this.activeModal.close(ModalResult.ACTIVATION_CANCEL);
  }

  public backToFirstView(): void {
    this.showDiv.current = true;
    this.showDiv.next = false;
    this.selectedPacket = null;
  }

  public backToSecondView(): void {
    if (this.isDirectFlag) {
      this.showDiv.last = false;
      this.backToFirstView();
      return;
    }
    this.showDiv.current = false;
    this.showDiv.last = false;
    this.showDiv.next = true;
    this.selectedPacket = null;
  }
}
